import { BitrixVue } from "ui.vue";
BitrixVue.component("ResultBlockImage", {
	props: ["state", "resultImage"],
	template: `
    <div class="result-block__doors justify-center">
        <div class="result-block__door">
				<img class="result-block__door-img" :src="resultImage" alt=""></div>
    </div>
`,
});
